import {Button, Form, Radio, Space, Input} from "antd";
import { useEffect } from "react";
import { useStore } from "../../config/store";
import { IClean, OBJECT_STATES } from "../../config/types";

export const FinishBlock = () => {
  const { loading, clean, cancelDrawer, finishClean } = useStore();
  const { id, object_state, object_state_comment } = clean as IClean;
  const [form] = Form.useForm();
  const objectState = Form.useWatch('object_state', form);

  useEffect(() => {
    form.setFieldsValue({
        object_state: object_state,
        object_state_comment: object_state_comment,
      });
  }, [form, object_state, object_state_comment]);

  const submitHandler = async (values: any) => {
    await finishClean({ clean_id: id, ...values });
  };


  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Form
        form={form}
        onFinish={submitHandler}
        layout="vertical"
        autoComplete="off"
      >
        <Form.Item
          name="object_state"
          label="Состояние объекта после гостей"
          rules={[{ required: true, message: "Необходимо выбрать состояние" }]}
        >
          <Radio.Group size="large">
            {Object.keys(OBJECT_STATES).map((item) => (
              <Radio.Button key={item} value={item}>
                {OBJECT_STATES[item]}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Form.Item>
        {objectState === 'has_problems' && <Form.Item
          name="object_state_comment"
          label="Текст проблемы"
          rules={[
            {
              required: true,
              message: "Необходимо указать причину"
            }
          ]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>}
        <Button
          type="primary"
          block
          size="large"
          htmlType="submit"
          loading={loading}
        >
          Закончить уборку
        </Button>
      </Form>
      <Button block size="large" onClick={cancelDrawer} loading={loading}>
        Отмена
      </Button>
    </Space>
  );
};
